import { Theme } from "../../../../components/constants";

export default {
    payerInformationContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    },

    gapBetween: {
        display: 'flex',
        columnGap: '6px',
        alignItems: 'center',
        color: Theme.DISABLED_TEXT
    },

    separator: {
        margin: '0px 10px'
    },

    payerName: {
        fontSize: '16px',
        marginBottom: '10px'
    },

    detailsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px'
    },

    payerType: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },

    recipientNumber: {
        margin: '0px 0px 0px auto',
        fontSize: '12px',
        color: Theme.TEXT_PRIMARY_BLACK
    },

    cursor: {
        cursor: "pointer"
    }
}